// extracted by mini-css-extract-plugin
export default {"title":"KtoW6e","minimized":"RZv9Uw"};